<template>
  <div v-if="product && product.id">
    <modal-component v-if="edit" v-model="modal.editProduct.active">
      <div slot="title">{{ modal.editProduct.title }}</div>
      <edit-product
        :inModal="true"
        :productID="editProductID"
        :createAlert="false"
        @updated="closeCreateProductModal"
      ></edit-product>
    </modal-component>

    <div class="leading-none my-4">
      <p class="text-sm font-bold text-theme-darker light:text-theme-lighter">#{{ product.id }}</p>
      <p class="text-2xl font-bold">{{ product.name }}</p>
      <p class="text-theme-darker light:text-theme-lighter">{{ product.code }}</p>
    </div>

    <div class="w-full overflow-x-auto">
      <table class="w-full text-sm">
        <tbody>
          <tr>
            <td><strong>Type:</strong> {{ product.type }}</td>
            <td><strong>Stock:</strong> {{ product.stock }}</td>
          </tr>
          <tr>
            <td><strong>Purchase price:</strong> {{ $formatMoney(product.purchase_price) }}</td>
            <td><strong>Purchase tax:</strong> {{ product.purchase_tax }}%</td>
          </tr>
          <tr>
            <td><strong>Sale price:</strong> {{ $formatMoney(product.sale_price) }}</td>
            <td><strong>Sale tax:</strong> {{ product.sale_tax }}%</td>
          </tr>
        </tbody>
      </table>
    </div>

    <button
      v-if="edit && hasPermission('product.edit')"
      type="button"
      class="btn btn-blue my-4 py-2 px-3"
      @click="editProduct"
    >
      <i class="fas fa-edit"></i>
      <span class="ml-2">Edit product</span>
    </button>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const EditProduct = resolve => require(['@/components/pages/products/Edit'], resolve)
const ModalComponent = resolve => require(['@/components/Modal'], resolve)

export default {
  props: {
    product: Object,
    edit: Boolean,
  },
  components: {
    EditProduct,
    ModalComponent,
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  data() {
    return {
      editProductID: null,
      modal: {
        editProduct: {
          active: false,
          title: '',
        }
      },
    }
  },
  methods: {
    editProduct() {
      this.editProductID = this.product.id
      // show modal
      this.modal.editProduct.title = 'Edit product'
      this.modal.editProduct.active = true
    },
    closeCreateProductModal(product) {
      // close modal
      this.modal.editProduct.active = false

      // emit to parent
      this.$emit('updated', product)
    },
  }
}
</script>
